import { CheckIcon } from "lucide-react";
import { Link } from "react-router-dom";

import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { formatCurrency } from "@tudigo-monorepo/core-tudigo-utils";
import { ButtonRebrand } from "@tudigo-monorepo/web-tudigo-components";

import { FeaturedFinishedProjects } from "./featured-finished-projects/featured-finished-projects";

const TOTAL_AMOUNT_RAISED = 192_000_000_00;
const ROUNDED_FINANCED_PROJECTS_COUNT = 300;
const highlightsItems = [
  "certified",
  "process",
  "deals",
  "partnership",
  "income_tax",
] as const;

export function TrackRecordBlock() {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto w-full px-4 py-10">
      <div className="relative flex items-center lg:min-h-[421px] lg:gap-16">
        <FeaturedFinishedProjects />

        <div className="font-roobert flex flex-col items-center gap-y-6 lg:items-start">
          <div className="flex flex-col text-center lg:text-start">
            <h2 className="text-black-primary mb-2 text-[32px] font-semibold leading-8 lg:leading-[35px]">
              {t("search_projects_page.started.track_record_block.title", {
                amount: formatCurrency(TOTAL_AMOUNT_RAISED),
              })}
            </h2>
            <p className="text-black-900 text-lg leading-[22px]">
              {t("search_projects_page.started.track_record_block.subtitle", {
                projectsCount: ROUNDED_FINANCED_PROJECTS_COUNT,
              })}
            </p>
          </div>

          <ul className="flex flex-col gap-y-4">
            {highlightsItems.map((key, index) => (
              <li key={index} className="flex items-center gap-x-4">
                <span className="bg-accent-super-light-rebrand flex h-[30px] min-h-[30px] w-[30px] min-w-[30px] items-center justify-center rounded-full">
                  <CheckIcon className="text-accent h-5 w-5 stroke-2" />
                  <span className="sr-only">Check</span>
                </span>
                <p className="text-black-primary text-balance lg:text-pretty">
                  {t(
                    `search_projects_page.started.track_record_block.highlights.${key}`,
                  )}
                </p>
              </li>
            ))}
          </ul>

          <ButtonRebrand asChild>
            <Link to="financed">
              {t(
                "search_projects_page.started.track_record_block.financed_page_link.label",
              )}
            </Link>
          </ButtonRebrand>
        </div>
      </div>
    </div>
  );
}
